import { Reveal } from "./Reveal";
import { Zap, BookOpen, MoonStar } from "lucide-react";

const STEPS = [
  { icon: Zap, title: "Download instantly", text: "The 16-page PDF lands in your inbox seconds after checkout — read it on phone, tablet, or print it." },
  { icon: BookOpen, title: "One chapter per night", text: "Five minutes of reading, one small exercise. Seven nights, seven levers — each one makes the next easier." },
  { icon: MoonStar, title: "Sleep different", text: "Most readers feel the shift between nights 3 and 5. The 30-night tracker then locks the habit in for good." },
];

export function HowItWorks() {
  return (
    <section id="how" data-testid="how-it-works" className="border-y border-white/10 bg-[#0e131f]">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:py-28">
        <Reveal>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-cyan-400/90">How It Works</p>
          <h2 className="font-display mt-3 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            Read. One exercise. Sleep.
          </h2>
        </Reveal>
        <div className="mt-12 grid gap-10 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.12}>
              <div className="relative" data-testid={`how-it-works-step-${i + 1}`}>
                <span className="font-display absolute -top-6 right-0 text-7xl font-extrabold text-white/5">0{i + 1}</span>
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-2xl border border-cyan-400/30 bg-cyan-400/10">
                  <s.icon className="h-5 w-5 text-cyan-300" />
                </div>
                <h3 className="font-display text-lg font-semibold text-white sm:text-xl">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
